import config from "./config";

const {TERMS_AND_CONDITIONS_URL} = config;

const profile = {
    settings: ["linkEmail", "changePassword", "language", "logOut"],
    tutorial: ["accountSettings", "leagueGames", "clubs", "shop", "dailyBonus", "accountLevelsAndXP", "friendInvite"],
    about: ["gameRules", "contactInfo"]
}

if (TERMS_AND_CONDITIONS_URL){
    profile.about.push('termsAndConditions', 'privacyPolicy')
}

export default profile;